// import logo from 'C:/cursor projects/yoganewesttry/frontend/public/images/logos/yoga-center-logo.png';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getConfig, ENV } from '../../utils/config';
import tideaLogo from './image/artfooter.png';
import PrivacyPolicyPopup from '../popups/PrivacyPolicyPopup';
import TermsConditionsPopup from '../popups/TermsConditionsPopup';
import CreatorPopup from '../popups/CreatorPopup';
import './Footer.css';

const Footer = () => {  
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [subscribeError, setSubscribeError] = useState('');
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsConditions, setShowTermsConditions] = useState(false);
  const [showCreatorInfo, setShowCreatorInfo] = useState(false);
  const navigate = useNavigate();
  
  const currentLanguage = i18n.language;
  const isSlovak = currentLanguage === 'sk';
  
  const scrollToSection = (sectionId) => {
    // If we're on the home page
    if (window.location.pathname === '/') {
      // Special case for scrolling to top
      if (sectionId === 'top') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      
      // Special case for the About section which has ID 'about-us'
      if (sectionId === 'about') {
        sectionId = 'about-us';
      }
      
      // Special case for the Schedule section which is inside the schedule-section div
      if (sectionId === 'schedule') {
        const scheduleSection = document.querySelector('.schedule-section');
        if (scheduleSection) {
          scheduleSection.scrollIntoView({ behavior: 'smooth' });
          return;
        }
      }
      
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If we're on another page, navigate to home then scroll
      navigate('/');
      // Wait for navigation to complete
      setTimeout(() => {
        if (sectionId === 'top') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        
        // Special case for the About section which has ID 'about-us'
        if (sectionId === 'about') {
          sectionId = 'about-us';
        }
        
        // Special case for the Schedule section which is inside the schedule-section div
        if (sectionId === 'schedule') {
          const scheduleSection = document.querySelector('.schedule-section');
          if (scheduleSection) {
            scheduleSection.scrollIntoView({ behavior: 'smooth' });
            return;
          }
        }
        
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    // Reset any previous errors
    setSubscribeError('');
    
    try {
      // Call the newsletter subscription API
      const response = await axios.post('newsletter/subscribe', { email });
      
      // Show success message
      setSubscribed(true);
      setEmail('');
      
      // Reset the success message after 5 seconds
      setTimeout(() => {
        setSubscribed(false);
      }, 5000);
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setSubscribeError(error.response?.data?.error || t('subscription_error'));
      
      // Reset the error message after 5 seconds
      setTimeout(() => {
        setSubscribeError('');
      }, 5000);
    }
  };
  
  return (
    <footer className="site-footer" lang={currentLanguage} itemScope itemType="https://schema.org/WPFooter">
      <div className="container">
        <div className="footer-top">
          
        </div>
        
        <div className="footer-content">
          <div className="footer-section about">
            <div className="footer-logo">
              <div className="footer-image logo-ellipse">
                <img src={tideaLogo} alt={isSlovak ? "TiDeaSolis logo" : "TiDeaSolis logo"} className="footer-logo-img" itemProp="image" />
              </div>    
            </div>
            {/* <div className="hours-info">
              <h4>Otváracie hodiny</h4>
              <p>Pondelok - Piatok: 7:00 - 21:00</p>
              <p>Sobota: 9:00 - 18:00</p>
              <p>Nedeľa: 9:00 - 16:00</p>
            </div> */}
          </div>
          
          <div className="footer-section links">
            <h3 className="footer-heading">{t('quick_links')}</h3>
            <ul className="footer-links">
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('top'); }} lang={currentLanguage}><i className="fas fa-chevron-right"></i> {t('home')}</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('schedule'); }} lang={currentLanguage}><i className="fas fa-chevron-right"></i> {t('schedule')}</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }} lang={currentLanguage}><i className="fas fa-chevron-right"></i> {t('about')}</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('instructors'); }} lang={currentLanguage}><i className="fas fa-chevron-right"></i> {t('instructors')}</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('workshops'); }} lang={currentLanguage}><i className="fas fa-chevron-right"></i> {t('workshops')}</a></li>
            </ul>
          </div>
          
          <div className="footer-section contact" itemScope itemType="https://schema.org/LocalBusiness">
            <meta itemProp="name" content="TiDeaSolis Yoga Štúdio" />
            <meta itemProp="image" content={tideaLogo} />
            <meta itemProp="url" content={window.location.origin} />
            <meta itemProp="priceRange" content="€€" />
            
            <h3 className="footer-heading">{t('contact')}</h3>
            <ul className="contact-list">
              <li>
                <i className="fas fa-map-marker-alt contact-icon"></i>
                <span itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                  <meta itemProp="addressCountry" content="SK" />
                  <meta itemProp="addressLocality" content="Rožňava" />
                  <span itemProp="streetAddress">{t('contact_address')}</span>
                </span>
              </li>
              <li>
                <i className="fas fa-phone-alt contact-icon"></i>
                <span itemProp="telephone">+421 907 510 511</span>
              </li>
              <li>
                <i className="fas fa-envelope contact-icon"></i>
                <span itemProp="email">tideasolis@gmail.com</span>
              </li>
            </ul>
            
            <div className="social-icons-contact">
              <h4>{t('follow_us')}</h4>
              <div className="social-icons">
                <a href="https://www.facebook.com/profile.php?id=61551793443459" target="_blank" rel="noreferrer" className="social-icon facebook" title={isSlovak ? "TiDeaSolis na Facebooku" : "TiDeaSolis on Facebook"}>
                  <i className="fab fa-facebook-f"></i>
                  <span className="sr-only">{isSlovak ? "Facebook" : "Facebook"}</span>
                </a>
                <a href="https://www.instagram.com/tideasolisyoga/?hl=cs" target="_blank" rel="noreferrer" className="social-icon instagram" title={isSlovak ? "TiDeaSolis na Instagrame" : "TiDeaSolis on Instagram"}>
                  <i className="fab fa-instagram"></i>
                  <span className="sr-only">{isSlovak ? "Instagram" : "Instagram"}</span>
                </a>
                <a href="https://www.youtube.com" target="_blank" rel="noreferrer" className="social-icon youtube" title={isSlovak ? "TiDeaSolis na YouTube" : "TiDeaSolis on YouTube"}>
                  <i className="fab fa-youtube"></i>
                  <span className="sr-only">{isSlovak ? "YouTube" : "YouTube"}</span>
                </a>
                {/* <a href="https://www.tiktok.com" target="_blank" rel="noreferrer" className="social-icon tiktok">
                  <i className="fab fa-tiktok"></i>
                </a> */}
                
              </div>
              {/* <div className="decorative-dots">
                <span className="dot dot-1"></span>
                <span className="dot dot-2"></span>
                <span className="dot dot-3"></span>
              </div> */}
            </div>
          </div>
          
          <div className="footer-section newsletter">
            <h3 className="footer-heading">{t('subscribe_to_newsletter')}</h3>
            <p className="footer-text">
              {t('newsletter_description')}
            </p>
            <form onSubmit={handleSubscribe} className="subscription-form" aria-label={isSlovak ? "Formulár na odber newslettera" : "Newsletter subscription form"}>
              <div className="form-group">
                <input
                  type="email"
                  placeholder={t('your_email')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="subscription-input"
                  aria-label={isSlovak ? "Váš email" : "Your email"}
                  lang={currentLanguage}
                />
                <button 
                  type="submit" 
                  className="subscription-button"
                  aria-label={isSlovak ? "Prihlásiť sa na odber" : "Subscribe"}
                  title={isSlovak ? "Prihlásiť sa na odber" : "Subscribe"}
                >
                  <i className="fas fa-paper-plane"></i>
                </button>
              </div>
              {subscribed && (
                <p className="subscription-message success" role="alert">
                  <i className="fas fa-check-circle"></i> {t('subscription_success')}
                </p>
              )}
              {subscribeError && (
                <p className="subscription-message error" role="alert">
                  <i className="fas fa-exclamation-circle"></i> {subscribeError}
                </p>
              )}
            </form>
            
            {/* <div className="payment-methods">
              <h4>Akceptujeme</h4>
              <div className="payment-icons">
                <span><i className="fab fa-cc-visa"></i></span>
                <span><i className="fab fa-cc-mastercard"></i></span>
                <span><i className="fab fa-apple-pay"></i></span>
                <span><i className="fab fa-google-pay"></i></span>
              </div>
            </div> */}
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} TiDeaSolis Yoga Štúdio. {t('all_rights_reserved')}</p>
          </div>
          {/* <div className="recaptcha-compliance">
            {isSlovak ? (
              <>
                Táto stránka je chránená službou reCAPTCHA a platia 
                <a href="https://policies.google.com/privacy" hrefLang="sk"> Zásady ochrany osobných údajov</a> a
                <a href="https://policies.google.com/terms" hrefLang="sk"> Podmienky služby</a> spoločnosti Google.
              </>
            ) : (
              <>
                This site is protected by reCAPTCHA and the Google 
                <a href="https://policies.google.com/privacy"> Privacy Policy</a> and
                <a href="https://policies.google.com/terms"> Terms of Service</a> apply.
              </>
            )}
          </div> */}
          <div className="footer-bottom-links">
            <a 
              href="#" 
              onClick={(e) => { e.preventDefault(); setShowPrivacyPolicy(true); }}
              lang={currentLanguage} 
              hrefLang={currentLanguage}
            >{t('privacy_policy')}</a>
            <a 
              href="#" 
              onClick={(e) => { e.preventDefault(); setShowTermsConditions(true); }}
              lang={currentLanguage} 
              hrefLang={currentLanguage}
            >{t('terms_conditions')}</a>
            <a 
              href="https://www.synapsespider.com"
              target="_blank"
              rel="noreferrer"
              className="creator-link synase-card"
              title="synasespider.com"
            >
              <img src="/images/synasespider-logo.png" alt="Synase Spider" className="synase-logo" onError={(e) => { e.target.style.display='none'; }} />
              <span className="creator-link-text">synasespider.com</span>
            </a>
          </div>
        </div>
      </div>

      {showPrivacyPolicy && <PrivacyPolicyPopup onClose={() => setShowPrivacyPolicy(false)} />}
      {showTermsConditions && <TermsConditionsPopup onClose={() => setShowTermsConditions(false)} />}
      {showCreatorInfo && <CreatorPopup onClose={() => setShowCreatorInfo(false)} />}
    </footer>
  );
};

export default Footer; 